import { put, select, takeEvery, takeLatest } from "redux-saga/effects";

import { GuideUserStatus } from "@mapmycustomers/shared/types/entity";
import Organization from "@mapmycustomers/shared/types/Organization";
import ListResponse from "@mapmycustomers/shared/types/viewModel/ListResponse";

import { callApi } from "@app/store/api/callApi";
import { handleError } from "@app/store/errors/actions";
import { getOrganizationId } from "@app/store/iam";

import { refreshGuidesStatus, updateGuideStatus } from "./actions";

function* onRefreshGuideStatuses() {
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const statusResponse: ListResponse<GuideUserStatus> = yield callApi(
      "fetchGuidesStatus",
      orgId,
      { $limit: -1 }
    );
    yield put(refreshGuidesStatus.success({ guidesStatus: statusResponse.data }));
  } catch {
    yield put(refreshGuidesStatus.failure());
  }
}

function* onUpdateGuideStatus({ payload }: ReturnType<typeof updateGuideStatus.request>) {
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    yield callApi("updateGuideProgress", orgId, payload);
    yield put(updateGuideStatus.success());
  } catch (error) {
    yield put(handleError({ error }));
    yield put(updateGuideStatus.failure());
  }
}

export function* onboardingSaga() {
  yield takeLatest(refreshGuidesStatus.request, onRefreshGuideStatuses);
  yield takeEvery(updateGuideStatus.request, onUpdateGuideStatus);

  // also force-refresh guides status when any flow progress happens:
  yield takeLatest(updateGuideStatus.success, onRefreshGuideStatuses);
}
